/** PM Drafts — localStorage draft persistence and server draft helpers. */

// Local draft persistence — survives page refresh
const DRAFT_STORAGE_KEY = 'pm_drafts';

window.draftStorage = {
  // Empty string sentinel means "user cleared the draft" vs key missing means "no local data"
  save(threadId, text) {
    if (!threadId) return;
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      drafts[threadId] = text || '';
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(drafts));
    } catch { /* quota exceeded or private browsing */ }
  },
  load(threadId) {
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      return threadId in drafts ? drafts[threadId] : null;
    } catch { return null; }
  },
  remove(threadId) {
    if (!threadId) return;
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      delete drafts[threadId];
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(drafts));
    } catch { /* ignore */ }
  }
};

// Debounced server-side draft save — fires 2s after user stops typing
var _draftSaveTimer = null;
var _lastSavedDraft = {};

function saveDraftToServer() {
  var threadId = window.get_active_thread_id();
  if (!threadId) return;

  var message = $.trim($("#message").val()) || '';

  // Skip if unchanged since last server save
  if (_lastSavedDraft[threadId] === message) return;
  _lastSavedDraft[threadId] = message;

  $.ajax({
    type: "POST",
    url: "/app/messages/update",
    data: {
      "thread": threadId,
      "draft": { "message": message }
    },
    dataType: "json"
  }).done(function(data) {
    if (data && data.ok === false) {
      delete _lastSavedDraft[threadId];
    }
  }).fail(function() {
    delete _lastSavedDraft[threadId];
  });
}

$(document).on("input", "#message", function() {
  clearTimeout(_draftSaveTimer);
  _draftSaveTimer = setTimeout(saveDraftToServer, 2000);

  var threadId = window.get_active_thread_id();
  if (threadId) {
    var val = $(this).val();
    // Keep in-memory draft cache in sync for thread-view.js
    window.last_draft[threadId] = val;
    // Also persist to localStorage immediately
    window.draftStorage.save(threadId, val);
  }
});

window["auto_save_intvl"] = 60000;
window["DraftAutoSave"] = function() {
  $("#saveDraftBtn").trigger("click");
  window.setTimeout("DraftAutoSave()", window.auto_save_intvl);
};
